import { filter, indexOf } from 'lodash';

import type { GetRelationshipsResponse } from '@appTypes/esb';
import { allowedReversedPGRelationships } from '@shared/constants';

export default (relationships: GetRelationshipsResponse) =>
  filter(
    relationships,
    relationship =>
      indexOf(allowedReversedPGRelationships, relationship.relationship) !== -1,
  );
